import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Mtrwf { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNumber() 
    WF001: number = 0;            // 編號 6 

    @MaxLength(10,{message: '使用者 (WF002) 資料太長'})
    WF002: string = '';            // 使用者 10 

    @MaxLength(10,{message: '分類 (WF003) 資料太長'})
    WF003: string = '';            // 分類 10 Hidden

    @MaxLength(60,{message: '名稱 (WF004) 資料太長'})
    WF004: string = '';            // 名稱 60 

    @MaxLength(255,{message: '網址 (WF005) 資料太長'})
    WF005: string = '';            // 網址 255 

    @MaxLength(4,{message: '自行排序碼 (WF006) 資料太長'})
    WF006: string = '';            // 自行排序碼 4 Hidden,改用名稱排序

    @IsNumber() 
    WF007: number = 0;            // 點閱次數 6 

    @IsNumber() 
    WF008: number = 0;            // 上層編號 6 


}
